// src/features/dashboard/dashboard.routes.js
import DashboardView from './DashboardView.vue';

const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardView,
    meta: {
      requiresAuth: true, // Dashboard requires authentication
    },
  },
];

export default dashboardRoutes;
